import * as React from "react";

import { useAppDispatch, useAppSelector } from "app.hook";
import { shallowEqual } from "react-redux";
import { selectBranches, setBranchCookie } from "states/branch/branch.slice";
import { IBranchModel } from "states/branch/branch.models";
import { RootState } from "app.store";
import { selectedBranchShoppingCart } from "states/shopping-cart/shopping-cart.slice";
import { fetchBranchOrderPickupSetting } from "states/branch-order-pickup-setting/order-pickup-setting.slice";

export function SelectBranchModal() {
  const branches = useAppSelector(selectBranches, shallowEqual);
  const currentBranch = useAppSelector(
    (state: RootState) => state.shoppingCart.shoppingCart.branch,
    shallowEqual
  );
  const dispatch = useAppDispatch();
  return (
    <select
      value={currentBranch.id}
      name="selectBranch"
      className="form-control w-full py-2 mb-4"
      onChange={(ev) => {
        let branch = branches.find((m) => m.id === Number(ev.target.value));
        setBranchCookie(branch?.id?.toString() ?? "");
        dispatch(selectedBranchShoppingCart(branch ?? ({} as IBranchModel)));
        
      }}
    >
      <option value="">
        Select Location
      </option>
      {branches?.filter(m => m.isActive)?.map((m) => (
        <option key={m.id} value={m.id} selected={currentBranch.id === m.id}>
          {m.name}
        </option>
      ))}
    </select>
  );
}
